// Array extension
Array.prototype.isEmpty = function () {
    return this.length === 0;
};
Array.prototype.isNotEmpty = function () {
    return this.length > 0;
};
// String extension
String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
};

// Date extension
Date.prototype.isToday = function () {
    const today = new Date();
    return this.toISOString().startsWith(today.toISOString().split('T')[0]);
};

Date.prototype.isSame = function (otherDate: Date, type: Date.IsSameType = 'day', dowOffset: number = 1) {
    // from `2023-07-10T12:33:25.975Z` to [date: 2023-07-10, time: 12:33:25]
    const [date1, time1] = this.toISOString().slice(0, 19).split('T');
    const [date2, time2] = otherDate.toISOString().slice(0, 19).split('T');

    switch (type) {
        case 'second': return this.isSame(otherDate, 'day') && time1 === time2;
        case 'minute': return this.isSame(otherDate, 'day') && time1.startsWith(time2.slice(5));
        case 'hour': return this.isSame(otherDate, 'day') && time1.startsWith(time2.slice(2));
        case 'day': return date1 === date2;
        case 'week': return this.isSame(otherDate, 'year') && this.getWeek(dowOffset) === otherDate.getWeek(dowOffset);
        case 'month': return this.isSame(otherDate, 'year') && this.getMonth() === otherDate.getMonth();
        case 'year': return this.getFullYear() === otherDate.getFullYear();
    }
};

Date.prototype.getMinutesOfDay = function () {
    return this.getHours() * 60 + this.getMinutes();
};

/**
 * Returns the week number for this date. dowOffset is the day of week the week
 * "starts" on for your locale - it can be from 0 to 6. If dowOffset is 1 (Monday),
 * the week returned is the ISO 8601 week number.
 * @param int dowOffset
 * @return int
 */
Date.prototype.getWeek = function (dowOffset = 1) {
    /* getWeek() was developed by Nick Baicoianu at MeanFreePath: http://www.meanfreepath.com */

    dowOffset = typeof dowOffset === 'number' ? dowOffset : 0; // default dowOffset to zero
    const newYear = new Date(this.getFullYear(), 0, 1);
    let day = newYear.getDay() - dowOffset; // the day of week the year begins on
    day = day >= 0 ? day : day + 7;
    const daynum = Math.floor((this.getTime() - newYear.getTime()
        - (this.getTimezoneOffset() - newYear.getTimezoneOffset()) * 60000) / 86400000) + 1;
    let weeknum;
    // if the year starts before the middle of a week
    if (day < 4) {
        weeknum = Math.floor((daynum + day - 1) / 7) + 1;
        if (weeknum > 52) {
            const nYear = new Date(this.getFullYear() + 1, 0, 1);
            let nday = nYear.getDay() - dowOffset;
            nday = nday >= 0 ? nday : nday + 7;
            /* if the next year starts before the middle of
              the week, it is week #1 of that year */
            weeknum = nday < 4 ? 1 : 53;
        }
    } else {
        weeknum = Math.floor((daynum + day - 1) / 7);
    }
    return weeknum;
};

Date.prototype.isBefore = function (date: Date) {
    return this < date;
};

Date.prototype.isAfter = function (date: Date) {
    return this > date;
};
